var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddrHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_address") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_address",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3453909,16.1034256 L21.4078909,8.29069137 C20.8646764,7.90310288 20.1353241,7.90310288 19.5921096,8.29069137 L8.65460963,16.1034256 C8.24384336,16.3964612 8,16.8699435 8,17.3745314 L8,31.4374529 C8,31.8519381 8.16430976,32.2495146 8.45738632,32.5426 C8.75046289,32.8356853 9.14802747,33 9.56250025,33 L31.4375003,33 C31.851973,33 32.2495376,32.8356853 32.5426142,32.5426 C32.8356907,32.2495146 33,31.8519381 33,31.4374529 L33,17.3745314 C33,16.8699435 32.7561571,16.3964612 32.3453909,16.1034256 Z M18.9375003,29.8749061 L18.9375003,23.6247187 L22.0625003,23.6247187 L22.0625003,29.8749061 L18.9375003,29.8749061 Z M29.8750003,29.8749061 L25.1875003,29.8749061 L25.1875003,22.0621719 C25.1877353,21.6476867 25.0231907,21.2501102 24.7301142,20.9570248 C24.4370376,20.6639395 24.039473,20.49939 23.6250003,20.499625 L17.3750003,20.499625 C16.9605275,20.49939 16.5629629,20.6639395 16.2698863,20.9570248 C15.9768098,21.2501102 15.8122652,21.6476867 15.8125003,22.0621719 L15.8125003,29.8749061 L11.1250003,29.8749061 L11.1250003,18.1786701 L20.5000003,11.4814641 L29.8750003,18.1786701 L29.8750003,29.8749061 Z",
    id: "Shape",
    fill: "#252C48",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddrHistory);
export default __webpack_public_path__ + "static/media/addr_history.32cefe1692de763b34cfd2f0c6ed2e3c.svg";
export { ForwardRef as ReactComponent };